import { Outlet } from "react-router";
import Navbar from "../components/navbar/navbar";

const AdminLayout = () => {
  return (
    <>
      <Navbar hideMenu={false} />
      <div
        className="container"
        style={{ marginTop: "150px", paddingBottom: "5rem" }}
      >
        <Outlet />
      </div>
    </>
  );
};
export default AdminLayout;
